import { render, staticRenderFns } from "./pieArt.vue?vue&type=template&id=3c9ff904"
import script from "./pieArt.vue?vue&type=script&lang=js"
export * from "./pieArt.vue?vue&type=script&lang=js"
import style0 from "./pieArt.vue?vue&type=style&index=0&id=3c9ff904&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports